import styled from 'styled-components';

export const TopbarContainer = styled.nav`
  display: flex;
  align-items: center;
  width: 100%;
  position: sticky;
  top: 0;
  background: white;
  z-index: 1000;
  padding: 10px 0;

  @media (max-width: 600px) {
    padding: 8px 0;
  }
`;

export const StyledNavMobile = styled.div`
  display: flex;
  justify-content: start;
`;
